<rb-loading-spinner *ngIf="dataLoading" class="spinner"></rb-loading-spinner>
<div class="row ms-0 me-0" *ngIf="errorMessage && !dataLoading">
    <rb-callout type="warning">
        No data for "Vehicle Mileage" chart.
    </rb-callout>
</div>
<div id="vehicle-mileage-chart"></div>
<div class="p-2" *ngIf="!dataLoading && !errorMessage">
    <div class="shaded-container">
        Distribution of the current mileage <span>(in {{ getMileageUnit() }})</span> by the vehicles within your fleet along with the corresponding value(s) of the selected vehicle(s). The values are given as a percentage of the whole fleet.
    </div>
</div>